module.exports = {"431224100":"卢峰镇","431224101":"大江口镇","431224102":"低庄镇","431224103":"桥江镇","431224104":"龙潭镇","431224105":"均坪镇","431224106":"观音阁镇","431224107":"双井镇","431224108":"水东镇","431224109":"两丫坪镇","431224110":"黄茅园镇","431224111":"祖市殿镇","431224112":"葛竹坪镇","431224113":"深子湖镇","431224114":"思蒙镇","431224115":"三江镇","431224116":"统溪河镇","431224117":"北斗溪镇","431224204":"舒溶溪乡","431224213":"油洋乡","431224219":"小横垅乡","431224222":"淘金坪乡","431224223":"中都乡","431224224":"沿溪乡","431224230":"龙庄湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431224.json
// module id = 1753
// module chunks = 0